import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Swal from 'sweetalert2';
import { message } from 'antd';

import {
  Wrapper,
  HeadlineDiv,
  AnotherLink,
  Logo,
  Button
} from './ConfirmTrainerRemoval.style';

import logo from '../../../assets/connect-5-white.svg';
import Layout from '../../Layouts';
import { customSwal } from '../../../theme';

class ConfirmTrainerRemoval extends Component {
  handleSubmit = async e => {
    e.preventDefault();

    const { localLead, trainer } = this.props.match.params;

    try {
      await axios.delete(`/api/remove/${localLead}/${trainer}`).then(() => {
        Swal.fire({
          title: 'Success',
          text: 'You were successfully removed from the group!',
          confirmButtonText: 'Ok',
          ...customSwal
        });
        this.props.history.push(`/login/`);
      });
    } catch (err) {
      message.error(`Error!, Internal server Error`);
    }
  };

  render() {
    return (
      <Layout>
        <Wrapper>
          <HeadlineDiv>
            <AnotherLink to="/">
              <Logo src={logo} alt="img" />
            </AnotherLink>
          </HeadlineDiv>
          <p>
            Clicking the button below will remove you from your local
            lead&apos;s group of trainers.
          </p>
          <Button onClick={this.handleSubmit}>Remove me from the group!</Button>
        </Wrapper>
      </Layout>
    );
  }
}

export default connect()(ConfirmTrainerRemoval);
